import React from 'react'

const Pulse = ({ width }: { width: number }) => {
	return (
		<div className={`spinner`}>
			<svg
				viewBox='0 0 24 24'
				xmlns='http://www.w3.org/2000/svg'
				width={width}
				height={width}
			>
				<circle
					cx='12'
					cy='12'
					r='0'
					stroke='currentColor'
					fill='currentColor'
				>
					<animate
						attributeName='r'
						calcMode='spline'
						dur='1.2s'
						values='0;11'
						keySplines='.52,.6,.25,.99'
						repeatCount='indefinite'
					/>
					<animate
						attributeName='opacity'
						calcMode='spline'
						dur='1.2s'
						values='1;0'
						keySplines='.52,.6,.25,.99'
						repeatCount='indefinite'
					/>
				</circle>
			</svg>
		</div>
	)
}

export default Pulse
